<div class="associations_type row px-2 mb-2">
  <div class="col-4 associations_type_section font-bold">
    <p class="mb-1" *ngIf="additionalMetadataData.name">{{additionalMetadataData?.name}}</p>
    <p class="mb-1" *ngIf="additionalMetadataData.title">{{additionalMetadataData?.title}}</p>
  </div>
  <div class="col-6 associations_destination_taxonomy">
    <p class="mb-1" [innerHtml]="getHtml(additionalMetadataData, 'metadata_value')"></p>
  </div>

  <div class="col-2 text-right pr-1" *ngIf="viewMode==='edit' && !isRightPanel">
    <button type="button" class="btn btn-icon tooltip top sm position-relative font-1x d-inline-block custom-icon-size"
      data-tooltip="Edit" id="{{additionalMetadataData?.title}}edit"
    data-toggle="modal" [attr.aria-label]="'Edit metadata'"
      data-target="#editAddMetadata" (click)="onEditMetadataClick(additionalMetadataData)"><span class="sr-only">Opens in a new dialog</span>
      <em class="material-icons-outlined font-4x" aria-hidden="true">edit</em>
    </button>

    <button type="button" class="btn btn-icon tooltip top top-right position-relative d-inline-block custom-icon-size"
      data-tooltip="Delete metadata" [attr.aria-label]="'Delete metadata'" id="{{additionalMetadataData?.title}}delete"
      (click)="onDeleteClick(additionalMetadataData.metadata_id)">
      <em class="material-icons-outlined font-4x" aria-hidden="true">delete</em>
    </button>
  </div>
</div>